/**
 * Hardcoded Principal User Configuration
 * Ky user ka privilegje të plota si Principal
 */
export const HARDCODED_USER = {
  username: 'SOKOLITO',
  password: 'SAjdini199$', // Case sensitive
  isPrincipal: true,
  role: 'principal',
  name: 'SOKOLITO',
  // Mund të shtohen më shumë detaje nëse nevojiten
};

/**
 * Kontrollo nëse credentials përputhen me hardcoded user
 * @param {string} username - Username i dhënë
 * @param {string} password - Password i dhënë
 * @returns {boolean} - true nëse përputhen
 */
export const isHardcodedUser = (username, password) => {
  return username === HARDCODED_USER.username && 
         password === HARDCODED_USER.password;
};





